export class OfferProduct {
  product_type: string;
  product_description: string;

  constructor() {
    this.product_type = '';
    this.product_description = '';
  }
}
